import { MaterialListComponentTypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/material-list-component-type.enum';
import MaterialListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-list/material-list.entity';
import MaterialListComponentAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-list-component/material-list-component.entity';

import { BomComponent, BomModalData } from 'app/shared/components/bom-modal/bom-modal.types';

const FALLBACK_UNIT = { _id: '', code: '', name: '' } as const;

const toComponentType = (
  raw: MaterialListComponentTypeEnum | string | undefined
): BomComponent['componentType'] => {
  switch (raw) {
    case MaterialListComponentTypeEnum.MATERIAL:
    case 'MATERIAL':
      return 'MATERIAL';
    case MaterialListComponentTypeEnum.BOM:
    case 'BOM':
      return 'BOM';
    default:
      return (raw as BomComponent['componentType']) ?? 'MATERIAL';
  }
};

export const mapMaterialListToBomModalData = (
  list: MaterialListAttributes,
  components: MaterialListComponentAttributes[]
): BomModalData => {
  const baseUnit = list.baseUnitOfMeasure
    ? {
        _id: (list.baseUnitOfMeasure as any)?._id?.toString?.() ?? '',
        code: list.baseUnitOfMeasure.code ?? '',
        name: list.baseUnitOfMeasure.name ?? '',
      }
    : { ...FALLBACK_UNIT };

  return {
    code: list.code,
    name: list.name,
    externalKeys: list.externalKeys
      ? {
          code: list.externalKeys.code,
          _id: (list.externalKeys as any)?._id?.toString?.(),
        }
      : undefined,
    baseUnitOfMeasure: baseUnit,
    notes: list.notes,
    showAsTree: true,
    components: components.map(mapComponent(baseUnit)),
  };
};

const mapComponent = (parentBaseUnit: BomModalData['baseUnitOfMeasure']) =>
  (component: MaterialListComponentAttributes): BomComponent => {
    const componentType = toComponentType(component.componentType);
    const quantity = component.quantity ?? 0;
    const quantityUnit = component.quantityUnitOfMeasure
      ? {
          _id: (component.quantityUnitOfMeasure as any)?._id?.toString?.() ?? '',
          code: component.quantityUnitOfMeasure.code ?? '',
          name: component.quantityUnitOfMeasure.name ?? '',
        }
      : { ...parentBaseUnit };

    return {
      _id: (component as any)?._id?.toString?.() ?? '',
      componentType,
      material: component.material
        ? {
            _id: (component.material as any)?._id?.toString?.() ?? '',
            code: component.material.code ?? '',
            name: component.material.name ?? '',
            externalKeys: component.material.externalKeys
              ? { code: component.material.externalKeys.code }
              : undefined,
          }
        : undefined,
      BOM: component.BOM
        ? {
            _id: (component.BOM as any)?._id?.toString?.() ?? '',
            code: component.BOM.code ?? '',
            name: component.BOM.name ?? '',
          }
        : undefined,
      materialBOM: component.materialBOM
        ? {
            _id: (component.materialBOM as any)?._id?.toString?.() ?? '',
            code: component.materialBOM.code ?? '',
            name: component.materialBOM.name ?? '',
          }
        : undefined,
      soldQuantity: quantity,
      soldUnitOfMeasure: quantityUnit,
      baseQuantity: quantity,
      baseUnitOfMeasure: quantityUnit,
      pararellQuantity: 0,
      isReturnable: component.isReturnable ?? false,
      notes: component.notes,
    };
  };
